import React from 'react';
import Navbar from '../components/navbar';
import TechHero from './TechHero';
import Footer from '../components/footer';

const Technology: React.FC = () => {
  return (
    <div className="w-full bg-black min-h-screen">
      <Navbar />
      <TechHero />
      <Footer />
    </div>
  );
};

export default Technology;